// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1DlN2","buttons":"RemoveExpirationActionButtons_buttons___13IV"};